export const agingReportbyPaymentClassTableHeaderMain = [
  "Payment Class",
  "Customer",
  "Net Balance",
  "Overdue", //"Overdue + Debit - CD", //"Overdue",
  "Total CD Amount",
  //"Overdue > 60 days",
  //"Overdue > 90 days",
  "Provision amount",
];

export const agingReportbyPaymentClassTableDataMain = [
  "paymentClass",
  "totalCustomers",
  "total",
  "totalOverdue",
  "totalCDAmount",
  //"totalOverdueAbove60Days",
  //"totalOverdueAbove90Days",
  "totalProvisionAmount",
];

export const newAgeingReportbyRegionTableHeaderMain = [
  "Region",
  "Customer",
  "Net Balance",
  "Overdue", //"Overdue + Debit - CD",
  "Total CD Amount",
  //"Overdue > 60 days",
  //"Overdue > 90 days",
  "Provision amount",
];

export const newAgeingReportbyRegionTableDataMain = [
  "regionName",
  "totalCustomers",
  "total",
  "totalOverdue",
  "totalCDAmount",
  //"totalOverdueAbove60Days",
  //"totalOverdueAbove90Days",
  "totalProvisionAmount",
];

export const agingReportbyPaymentClassTableHeader = [
  "Payment Class",
  "Customer",
  "Net Balance",
  "Overdue", //"Overdue + Debit - CD", //"Overdue",
  "Total CD Amount",
  "Provision amount",
  "Balance CR/DR",
  "Debit Balance",
  //"Overdue > 60 days",
  //"Overdue > 90 days",
  "Amount >365 Days",
  "Amount 336-365 Days",
  "Amount 271-335 Days",
  "Amount 181-270 Days",
  "Amount 151-180 Days",
  "Amount 121-150 Days",
  "Amount 91-120 Days",
  "Amount 61-90 Days",
  "Amount 46-60 Days",
  "Amount 31-45 Days",
  "Amount 30 Days",
  "Amount 29 Days",
  "Amount 0-28 Days",
];

export const agingReportbyPaymentClassTableData = [
  "paymentClass",
  "totalCustomers",
  "total",
  "totalOverdue",
  "totalCDAmount",
  "totalProvisionAmount",
  "totalBalanceCrDr",
  "totalDebitBalance",
  //"totalOverdueAbove60Days",
  //"totalOverdueAbove90Days",
  "totalDaysAbove_365",
  "totalDays336_365",
  "totalDays271_335",
  "totalDays181_270",
  "totalDays151_180",
  "totalDays121_150",
  "totalDays91_120",
  "totalDays61_90",
  "totalDays46_60",
  "totalDays31_45",
  "totalDays_30",
  "totalDays_29",
  "totalDays0_28",
];

export const newAgeingReportbyRegionTableHeader = [
  "Region",
  "Customer",
  "Net Balance",
  "Overdue", //"Overdue + Debit - CD", //"Overdue",
  "Total CD Amount",
  "Provision amount",
  "Balance CR/DR",
  "Debit Balance",
  //"Overdue > 60 days",
  //"Overdue > 90 days",
  "Amount >365 Days",
  "Amount 336-365 Days",
  "Amount 271-335 Days",
  "Amount 181-270 Days",
  "Amount 151-180 Days",
  "Amount 121-150 Days",
  "Amount 91-120 Days",
  "Amount 61-90 Days",
  "Amount 46-60 Days",
  "Amount 31-45 Days",
  "Amount 30 Days",
  "Amount 29 Days",
  "Amount 0-28 Days",
];

export const newAgeingReportbyRegionTableData = [
  "regionName",
  "totalCustomers",
  "total",
  "totalOverdue",
  "totalCDAmount",
  "totalProvisionAmount",
  "totalBalanceCrDr",
  "totalDebitBalance",
  //"totalOverdueAbove60Days",
  //"totalOverdueAbove90Days",
  "totalDaysAbove_365",
  "totalDays336_365",
  "totalDays271_335",
  "totalDays181_270",
  "totalDays151_180",
  "totalDays121_150",
  "totalDays91_120",
  "totalDays61_90",
  "totalDays46_60",
  "totalDays31_45",
  "totalDays_30",
  "totalDays_29",
  "totalDays0_28",
];

export const agingReportbyStateTableHeaderMainView = [
  "State",
  "Customer",
  "Net Balance",
  "Overdue", //"Overdue + Debit - CD", //"Overdue",
  "Total CD Amount",
  //"Overdue > 60 days",
  //"Overdue > 90 days",
  "Provision amount",
];

export const agingReportbyStateTableDataMainView = [
  "stateName",
  "totalCustomers",
  "total",
  "totalOverdue",
  "totalCDAmount",
  //"totalOverdueAbove60Days",
  //"totalOverdueAbove90Days",
  "totalProvisionAmount",
];

export const agingReportbyStateTableHeader = [
  "State",
  "Customer",
  "Net Balance",
  "Overdue", //"Overdue + Debit - CD", //"Overdue",
  "Total CD Amount",
  //"Overdue > 60 days",
  //"Overdue > 90 days",
  "Provision amount",
  "Amount >365 Days",
  "Amount 336-365 Days",
  "Amount 271-335 Days",
  "Amount 181-270 Days",
  "Amount 151-180 Days",
  "Amount 121-150 Days",
  "Amount 91-120 Days",
  "Amount 61-90 Days",
  "Amount 46-60 Days",
  "Amount 31-45 Days",
  "Amount 30 Days",
  "Amount 29 Days",
  "Amount 0-28 Days",
];

export const agingReportbyStateTableData = [
  "stateName",
  "totalCustomers",
  "total",
  "totalOverdue",
  "totalCDAmount",
  //"totalOverdueAbove60Days",
  //"totalOverdueAbove90Days",
  "totalProvisionAmount",
  "totalDaysAbove_365",
  "totalDays336_365",
  "totalDays271_335",
  "totalDays181_270",
  "totalDays151_180",
  "totalDays121_150",
  "totalDays91_120",
  "totalDays61_90",
  "totalDays46_60",
  "totalDays31_45",
  "totalDays_30",
  "totalDays_29",
  "totalDays0_28",
];

export const totalOverdueByRegionTableListBody = [
  "regionName",
  "liveMonthVal",
  "febMonthVal",
  "janMonthVal",
  "decMonthVal",
  "novMonthVal",
  "octMonthVal",
  "sepMonthVal",
  "augMonthVal",
  "julMonthVal",
  "junMonthVal",
  "mayMonthVal",
  "aprMonthVal",
  "marMonthVal",
  "marMonthVal",
];

export const totalOverdueByRegionTableListBodyDetailedHeader = [
  "Region",
  "Live (Mar 2026)",
  "Prev Month (Feb 2026)",
  //"Feb 2025",
  "Jan 2026",
  "Dec 2025",
  "Nov 2025",
  "Oct 2025",
  "Sep 2025",
  "Aug 2025",
  "Jul 2025",
  "Jun 2025",
  "May 2025",
  "Apr 2025",
  "Prev Year (Mar 2025)",
  "Last Year L2L(Mar 2025)",
];

export const totalOverdueByRegionTableListHeaderMainView = [
  "Region",
  "Live (Mar 2026)",
  "Prev Month (Feb 2026)",
  "Prev Quarter (Dec 2025)",
  "Prev Year (Mar 2025)",
  "Last Year L2L(Mar 2025)",
];

export const totalOverdueByRegionTableListBodyMainView = [
  "regionName",
  "liveMonthVal",
  "febMonthVal",
  "decMonthVal",
  "marMonthVal",
  "marMonthVal",
];

export const totalOverdueByStateTableListBody = [
  "stateName",
  "liveMonthVal",
  "febMonthVal",
  "janMonthVal",
  "decMonthVal",
  "novMonthVal",
  "octMonthVal",
  "sepMonthVal",
  "augMonthVal",
  "julMonthVal",
  "junMonthVal",
  "mayMonthVal",
  "aprMonthVal",
  "marMonthVal",
  "marMonthVal",
];

export const totalOverdueByStateTableListBodyDetailedHeader = [
  "State",
  "Live (Mar 2026)",
  "Prev Month (Feb 2026)",
  //"Feb 2025",
  //"Jan 2025",
  "Jan 2026",
  "Dec 2025",
  "Nov 2025",
  "Oct 2025",
  "Sep 2025",
  "Aug 2025",
  "Jul 2025",
  "Jun 2025",
  "May 2025",
  "Apr 2025",
  "Prev Year (Mar 2025)",
  "Last Year L2L(Mar 2025)",
];

export const totalOverdueByStateTableListHeaderMainView = [
  "State",
  "Live (Mar 2026)",
  "Prev Month (Feb 2026)",
  "Prev Quarter (Dec 2025)",
  "Prev Year (Mar 2025)",
  "Last Year L2L(Mar 2025)",
];

export const totalOverdueByStateTableListBodyMainView = [
  "stateName",
  "liveMonthVal",
  "febMonthVal",
  "decMonthVal",
  "marMonthVal",
  "marMonthVal",
];

export const agingReportFutureODHeader = [
  "Customer Name",
  "Customer Code",
  "Net Balance",
  "Overdue",
  "Provision amount",
  "Security Deposit",
];

export const agingReportFutureODData = [
  "customerName",
  "customerCode",
  "netBalance",
  "overdue",
  "provisionAmount",
  "securityDeposit",
];

export const totalProvisionAmtByRegionTableListHeaderMainView = [
  "Region",
  "Live (Apr 2025)",
  "Mar 2025",
  "Dec 2024",
  "Sep 2024",
  "Jun 2024",
];

export const totalProvisionAmtByRegionTableListBodyMainView = [
  "regionName",
  "liveMonthVal",
  "marMonthVal",
  "decMonthVal",
  "sepMonthVal",
  "junMonthVal",
];

export const totalProvisionAmtByStateTableListHeaderMainView = [
  "State",
  "Live (Apr 2025)",
  "Mar 2025",
  "Dec 2024",
  "Sep 2024",
  "Jun 2024",
];

export const totalProvisionAmtByStateTableListBodyMainView = [
  "stateName",
  "liveMonthVal",
  "marMonthVal",
  "decMonthVal",
  "sepMonthVal",
  "junMonthVal",
];
export const agingReportFutureODProvRegionHeader = [
  "Region",
  "Customer",
  "Live OD",
  "Live Provision",
  "Future OD",
  "Future Provision",
  "Prev Year OD (Mar 2025)",
  "Prev Year Provision (Mar 2025)",
];

export const agingReportFutureODProvRegionDetail = [
  "regionName",
  "totalCustomers",
  "liveOverdue",
  "liveProvision",
  "futureOverdue",
  "futureProvision",
  "previousOverdue",
  "previousProvision",
];

export const agingReportFutureODProvStateHeader = [
  "State",
  "Customer",
  "Live OD",
  "Live Provision",
  "Future OD",
  "Future Provision",
  "Prev Year OD (Mar 2025)",
  "Prev Year Provision (Mar 2025)",
];

export const agingReportFutureODProvStateDetail = [
  "stateName",
  "totalCustomers",
  "liveOverdue",
  "liveProvision",
  "futureOverdue",
  "futureProvision",
  "previousOverdue",
  "previousProvision",
];

export const agingReportFutureODProvPartyWiseHeader = [
  "Customer Name",
  "Customer Code",
  "Division",
  "Live OD",
  "Live Provision",
  "Future OD",
  "Future Provision",
  "Prev Year OD (Mar 2025)",
  "Prev Year Provision (Mar 2025)",
  "Payment Class",
  "Average Payment Days",
];

export const agingReportFutureODProvPartyWiseDetail = [
  "customerName",
  "customerCode",
  "division",
  "liveOverdue",
  "liveProvision",
  "futureOverdue",
  "futureProvision",
  "previousOverdue",
  "previousProvision",
  "paymentClass",
  "averagePaymentDays",
];
